/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation } from "@tanstack/react-query";
import type {
    MutationFunction,
    QueryClient,
    UseMutationOptions,
    UseMutationResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { ApiKeyId, ApiKeyWithSecretDto, InsertableApiKey } from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const deleteApiKeysKeyId = (
    keyId: ApiKeyId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/api-keys/${keyId}`, options);
};

export const getDeleteApiKeysKeyIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteApiKeysKeyId>>,
        TError,
        { keyId: ApiKeyId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiKeysKeyId>>,
    TError,
    { keyId: ApiKeyId },
    TContext
> => {
    const mutationKey = ["deleteApiKeysKeyId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteApiKeysKeyId>>,
        { keyId: ApiKeyId }
    > = (props) => {
        const { keyId } = props ?? {};

        return deleteApiKeysKeyId(keyId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteApiKeysKeyIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteApiKeysKeyId>>
>;

export type DeleteApiKeysKeyIdMutationError = AxiosError<unknown>;

export const useDeleteApiKeysKeyId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteApiKeysKeyId>>,
            TError,
            { keyId: ApiKeyId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteApiKeysKeyId>>,
    TError,
    { keyId: ApiKeyId },
    TContext
> => {
    return useMutation(
        getDeleteApiKeysKeyIdMutationOptions(options),
        queryClient
    );
};
export const postApiKeys = (
    insertableApiKey: InsertableApiKey,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ApiKeyWithSecretDto>> => {
    return axios.post(`/api/api-keys`, insertableApiKey, options);
};

export const getPostApiKeysMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postApiKeys>>,
        TError,
        { data: InsertableApiKey },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postApiKeys>>,
    TError,
    { data: InsertableApiKey },
    TContext
> => {
    const mutationKey = ["postApiKeys"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postApiKeys>>,
        { data: InsertableApiKey }
    > = (props) => {
        const { data } = props ?? {};

        return postApiKeys(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostApiKeysMutationResult = NonNullable<
    Awaited<ReturnType<typeof postApiKeys>>
>;
export type PostApiKeysMutationBody = InsertableApiKey;
export type PostApiKeysMutationError = AxiosError<unknown>;

export const usePostApiKeys = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postApiKeys>>,
            TError,
            { data: InsertableApiKey },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postApiKeys>>,
    TError,
    { data: InsertableApiKey },
    TContext
> => {
    return useMutation(getPostApiKeysMutationOptions(options), queryClient);
};
